import request from 'request/index'
import auth from 'request/auth'
import { UC_RES, SessionStorage } from 'utils/config'
import parser from 'utils/parser'
import { TOKENS, AUTH, UC_SERVER_TIME } from 'utils/constants'
import { md5 } from 'utils/md5'

/**
 * 获取服务器时间
 * 接口信息地址：4.6.1 [GET]/server/time 获取服务器时间
 */
function sGetUCServerTime () {
  const serverTime = SessionStorage.get(UC_SERVER_TIME)
  if (serverTime && serverTime.hasOwnProperty('ms_format')) {
    return Promise.resolve(serverTime)
  }

  return request({
    method: 'GET',
    res: UC_RES,
    api: '/server/time'
  }).then(res => {
    // console.log('serverTime:L:L:L', res)
    res.firstTimestamp = new Date().getTime()
    SessionStorage.set(UC_SERVER_TIME, res)
    return Promise.resolve(res)
  }).catch(error => {
    return Promise.reject(error)
  })
}

function sCheckTokens ({
  access_token,
  nonce,
  mac,
  request_uri,
  host,
  http_method
}) {
  return request({
    method: 'POST',
    res: UC_RES,
    body: {
      nonce,
      mac,
      request_uri,
      host,
      http_method
    },
    api: '/tokens/{access_token}/actions/valid',
    params: {
      access_token
    }
  }).then(res => {
    return Promise.resolve(res)
  }).catch(error => {
    return Promise.reject(error)
  })
}

export default {
  /**
   * 获取tokens
   * 接口信息地址：http://wiki.sdp.nd/index.php?title=UC_API_RestfulV0.9#.5BPOST.5D.2Ftokens_.E7.94.A8.E6.88.B7.E7.99.BB.E5.BD.95
   */
  sGetTokens ({ login_name, password }) {
    return request({
      method: 'POST',
      res: UC_RES,
      body: {
        login_name,
        password: md5(password)
      },
      api: '/tokens'
    })
  },
  /**
   * 获取服务器时间
   * 接口信息地址：4.6.1 [GET]/server/time 获取服务器时间
   */
  sGetUCServerTime () {
    const serverTime = SessionStorage.get(UC_SERVER_TIME)
    if (serverTime && serverTime.hasOwnProperty('ms_format')) {
      return Promise.resolve(serverTime)
    }

    return request({
      method: 'GET',
      res: UC_RES,
      api: '/server/time'
    }).then(res => {
      // console.log('serverTime:L:L:L', res)
      res.firstTimestamp = new Date().getTime()
      SessionStorage.set(UC_SERVER_TIME, res)
      return Promise.resolve(res)
    }).catch(error => {
      return Promise.reject(error)
    })
  },

  sCheckTokens,

  sCheckTokensNew ({
    access_token,
    request_uri,
    host,
    http_method
  }) {
    let authorization = {}
    return sGetUCServerTime().then(res => {
      authorization = parser.parseToken(auth.getAuthorization(http_method, request_uri, host))
      Object.assign(authorization, {
        access_token,
        request_uri,
        host,
        http_method
      })
    }).then(() => {
      return sCheckTokens({ ...authorization })
    })
  },
  /**
   * 删除tokens
   * 接口信息地址：http://wiki.sdp.nd/index.php?title=UC_API_RestfulV0.9#.5BDELETE.5D.2Ftokens.2F.7Baccess_token.7D_.E9.80.80.E5.87.BA.E7.B3.BB.E7.BB.9F
   */
  sDelTokens () {
    const tokens = SessionStorage.get(TOKENS)
    if (tokens && tokens.access_token) {
      SessionStorage.remove(TOKENS)
      SessionStorage.remove(AUTH)
      return Promise.resolve()
    } else {
      // 如果本地登入tokens不存在，就默认发送登出成功的actions
      return Promise.resolve()
    }
  },
  /**
   * 从sesssion storage中获取token
   * @returns {*}
   */
  sGetTokenFromSStorage () {
    return SessionStorage.get(TOKENS)
  }
}



// WEBPACK FOOTER //
// ./src/apis/uc/token.js